export const ARTWORK_INFO_POPOVER_STYLES = {
    body: {
        maxHeight: 'calc(100vh - 96px)',
        overflowY: 'auto',
        overflowX: 'hidden',
        overscrollBehavior: 'contain',
    },
};

export const ARTWORK_INFO_MODAL_STYLES = {
    body: {
        maxHeight: 'calc(100vh - 200px)',
        overflowY: 'auto',
        overflowX: 'hidden',
        overscrollBehavior: 'contain',
    },
};
